<template>
  <v-row>

    <v-col cols="12" sm="3">
      <v-text-field
          prepend-icon="source"
          name="depto"
          v-model="form.origen"
          :label="$t('cobrox.persona.labels.origen')"
          :placeholder="$t('cobrox.persona.labels.origen')"
          :error="hasInputErrors('origen')"
          :error-messages="getInputErrors('origen')"
          color="secondary"
          :readonly="readonly"
      ></v-text-field>
    </v-col>

    <v-col cols="12" sm="3">
      <v-autocomplete
          v-model="form.tipo"
          :search-input.sync="search"
          :items="tipoItems"
          :label="$t('cobrox.persona.labels.tipo')"
          :readonly="readonly"
      >

      </v-autocomplete>

    </v-col>


    <v-col cols="12" sm="3">
      <v-text-field
          prepend-icon="email"
          name="mail"
          v-model="form.mail"
          :label="$t('cobrox.persona.labels.mail')"
          :placeholder="$t('cobrox.persona.labels.mail')"
          :error="hasInputErrors('mail')"
          :error-messages="getInputErrors('mail')"
          color="secondary"
          :readonly="readonly"
      ></v-text-field>
    </v-col>




  </v-row>
</template>

<script>
import {InputErrorsByProps, RequiredRule} from '@dracul/common-frontend'

export default {
  name: "PersonaEmailForm",
  mixins: [InputErrorsByProps, RequiredRule],
  props: {
    value: {
      type: Object,
      required: true
    },
    readonly: {type: Boolean, default:false}
  },
  data(){
    return {
      search: ''
    }
  },
  computed: {
    form: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    tipoItems(){
      return [this.search || '','Primario', 'Alternativo','Familiar', 'Vecino', 'Trabajo', 'Abogado']
    }
  },
  watch: {
    form: {
      handler(newVal) {
        this.$emit('input', newVal)
      },
      deep: true
    }
  },
}
</script>

<style scoped>

</style>
